const SET_LIST = (state, payload) => {
  state.list = payload
}

const SET_INVOICES_LIST = (state, payload) => {
  state.listInvoices = payload
}

const SET_GRAPH_INVOICES = (state, payload) => {
  state.graphInvoices = payload
}

export default {
  SET_LIST,
  SET_INVOICES_LIST,
  SET_GRAPH_INVOICES
}



// WEBPACK FOOTER //
// ./src/features/import_invoices/store/mutations.js